export default __webpack_public_path__ + "static/media/BrainBreak cards6.a187a46c.png";